/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TestGuardrailsRequest = {
  /**
   * Content to test against guardrails
   */
  content: string;
};

/** @internal */
export const TestGuardrailsRequest$inboundSchema: z.ZodType<
  TestGuardrailsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  content: z.string(),
});
/** @internal */
export type TestGuardrailsRequest$Outbound = {
  content: string;
};

/** @internal */
export const TestGuardrailsRequest$outboundSchema: z.ZodType<
  TestGuardrailsRequest$Outbound,
  z.ZodTypeDef,
  TestGuardrailsRequest
> = z.object({
  content: z.string(),
});

export function testGuardrailsRequestToJSON(
  testGuardrailsRequest: TestGuardrailsRequest,
): string {
  return JSON.stringify(
    TestGuardrailsRequest$outboundSchema.parse(testGuardrailsRequest),
  );
}
export function testGuardrailsRequestFromJSON(
  jsonString: string,
): SafeParseResult<TestGuardrailsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TestGuardrailsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TestGuardrailsRequest' from JSON`,
  );
}
